import { render, staticRenderFns } from "./DoctorCommisionReportTable.vue?vue&type=template&id=1d12d3cc&"
import script from "./DoctorCommisionReportTable.vue?vue&type=script&lang=js&"
export * from "./DoctorCommisionReportTable.vue?vue&type=script&lang=js&"
import style0 from "./DoctorCommisionReportTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports